<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>
      {{titulo}}
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <div [innerHTML]="data.texto"></div>
  </div>
  <mat-card>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-header class="header-padrao" [hidden]="isLoading">
      <mat-card-title>
        <div class="row" mat-dialog-actions>
          <div class="col">
            <form [formGroup]="selectForm" autocomplete="off">
              <mat-radio-group formControlName="tipoLote" aria-label="Selecione uma opção" color="primary"
                class="radio-group align-items-center" required>
                <div class="header-filter-log ">
                  <div class="row" style="display: inherit">
                    <fieldset class="acompanhantes-border d-flex align-items-center" style="min-height: 100px;">
                      <legend>Lote único</legend>
                      <mat-radio-button class="radio-button" [value]="false"></mat-radio-button>
                      <div  class="pb-3">
                        <table id="lote-geral" mat-table [dataSource]="gridLoteGeral" class="table-sm ml-3">
                          <ng-container matColumnDef="lotes">
                            <th mat-header-cell *matHeaderCellDef>Descrição</th>
                            <td mat-cell *matCellDef="let gridLoteGeral">
                              {{ gridLoteGeral.qtdItens }} CT-es - {{ gridLoteGeral.clienteDesc}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="freteTotal">
                            <th mat-header-cell *matHeaderCellDef>Frete Total</th>
                            <td mat-cell *matCellDef="let gridLoteGeral">
                              {{ gridLoteGeral.totalFrete | currency: 'BRL' }}
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
                      </div>
                    </fieldset>
                    <fieldset class="acompanhantes-border d-flex align-items-center" style="min-height: 100px;">
                      <legend>Lote por cliente</legend>
                      <mat-radio-button class="radio-button" [value]="true"></mat-radio-button>
                      <div  class="pb-3">
                        <table id="lote-cliente" mat-table [dataSource]="gridLotesPorCliente" class="table-sm ml-3">
                          <ng-container matColumnDef="lotes">
                            <th mat-header-cell *matHeaderCellDef>Descrição</th>
                            <td mat-cell *matCellDef="let gridLotesPorCliente">
                              {{ gridLotesPorCliente.qtdItens }} CT-es - {{ gridLotesPorCliente.clienteDesc}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="freteTotal">
                            <th mat-header-cell *matHeaderCellDef>Frete Total</th>
                            <td mat-cell *matCellDef="let gridLotesPorCliente">
                              {{ gridLotesPorCliente.totalFrete | currency: 'BRL'}}
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="displayedColumnsClient"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsClient"></tr>
                        </table>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </mat-radio-group>
            </form>
          </div>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="!selectForm.invalid">
      <div class="d-flex flex-column align-items-center">
        <p *ngIf="tipoLote === 'false'">
          Confirma o processamento de <strong>{{totalCte}}</strong> CT-es em <strong>lote
            único</strong>?
        </p>
        <p *ngIf="tipoLote === 'true'">
          Confirma o processamento de <strong>{{totalCte}}</strong> CT-es em
          <strong>{{gridLotesPorCliente.data.length}}</strong> lotes?
        </p>
        <div>
          <button mat-flat-button mat-dialog-close color="info" class="mr-3">{{textoCancelar}}</button>
          <button mat-flat-button mat-dialog-close style="background-color: #cddc39" (click)="confirm()">
            {{textoOk}}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>